(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dreamlover-review-questionnaire"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dreamlover-review-questionnaire')) {
    customElements.define('dreamlover-review-questionnaire', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.status = this.querySelector('[data-dl-status]');
        this.pendingProfile = '';
        this.bypassNativeButton = false;
        this.onDocumentClick = this.handleDocumentClick.bind(this);
        this.onNativeSubmit = this.handleNativeSubmit.bind(this);
        document.addEventListener('click', this.onDocumentClick, true);
        document.addEventListener('submit', this.onNativeSubmit, true);

        this.querySelectorAll('[data-dl-option]').forEach((button) => button.addEventListener('click', () => this.toggleOption(button)));
        this.querySelector('[data-dl-close]')?.addEventListener('click', () => this.close());
        this.querySelector('[data-dl-next]')?.addEventListener('click', () => this.showStep('needs'));
        this.querySelector('[data-dl-back]')?.addEventListener('click', () => this.showStep('profile'));
        this.querySelector('[data-dl-skip]')?.addEventListener('click', () => this.continueToNative(true));
        this.querySelector('[data-dl-finish]')?.addEventListener('click', () => this.continueToNative(false));
        this.dialog?.addEventListener('click', (event) => { if (event.target === this.dialog) this.close(); });

        this.widgetObserver = new MutationObserver(() => {
          this.decorateReviews();
          this.showProfileSummaryInNativeForm();
        });
        this.widgetObserver.observe(document.documentElement, { childList: true, subtree: true });
        this.decorateReviews();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick, true);
        document.removeEventListener('submit', this.onNativeSubmit, true);
        this.widgetObserver?.disconnect();
      }

      findNativeWriteButton() {
        return [...document.querySelectorAll('#judgeme_product_reviews button, #judgeme_product_reviews [role="button"], .jdgm-review-widget button, .jdgm-review-widget [role="button"]')]
          .find((button) => /write\s+a\s+review/i.test(button.textContent || ''));
      }

      isJudgeMeElement(element) {
        return Boolean(element?.closest?.('#judgeme_product_reviews, .jdgm-review-widget, .jdgm-review-widget-modal, .jdgm-write-review-modal, .jm-review-form, .jdgm-form-wrapper, [class*="jm-review-form"], [class*="jdgm-form"]'));
      }

      handleDocumentClick(event) {
        const button = event.target.closest?.('button, [role="button"]');
        if (!button || !this.isJudgeMeElement(button)) return;

        if (/write\s+a\s+review/i.test(button.textContent || '')) {
          if (this.bypassNativeButton) {
            this.bypassNativeButton = false;
            return;
          }
          event.preventDefault();
          event.stopImmediatePropagation();
          this.open();
          return;
        }

        if (this.isNativeSubmitButton(button)) this.prependProfileToReview();
      }

      isNativeSubmitButton(button) {
        return /submit|post|publish/i.test(button.textContent || '') && this.isJudgeMeElement(button);
      }

      handleNativeSubmit(event) {
        if (this.isJudgeMeElement(event.target)) this.prependProfileToReview();
      }

      open() {
        this.reset();
        this.dialog?.showModal();
      }

      close() { this.dialog?.close(); }

      reset() {
        this.showStep('profile');
        this.querySelectorAll('[data-dl-option]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
        const other = this.querySelector('[data-dl-other]');
        if (other) other.value = '';
      }

      showStep(name) {
        this.querySelectorAll('[data-dl-step]').forEach((step) => {
          const active = step.dataset.dlStep === name;
          step.hidden = !active;
        });
      }

      toggleOption(button) {
        const group = button.closest('[data-dl-group]');
        const next = button.getAttribute('aria-pressed') !== 'true';
        if (group?.dataset.dlMode === 'single') group.querySelectorAll('[data-dl-option]').forEach((option) => option.setAttribute('aria-pressed', 'false'));
        button.setAttribute('aria-pressed', String(next));
      }

      selected(groupName) {
        return [...this.querySelectorAll(`[data-dl-group="${groupName}"] [data-dl-option][aria-pressed="true"]`)].map((button) => button.value);
      }

      buildProfile() {
        const age = this.selected('age')[0];
        const worn = this.selected('worn');
        const matters = this.selected('matters');
        const other = this.querySelector('[data-dl-other]')?.value.trim();
        const lines = [];
        if (age && age !== 'Prefer not to say') lines.push(`Age range: ${age}`);
        if (worn.length) lines.push(`How it’s worn: ${worn.join(', ')}`);
        if (matters.length) lines.push(`What matters most: ${matters.join(', ')}`);
        if (other) lines.push(`Something else: ${other}`);
        return lines.length ? `[DL_PROFILE]\n${lines.join('\n')}\n[/DL_PROFILE]\n\n` : '';
      }

      continueToNative(skip) {
        this.pendingProfile = skip ? '' : this.buildProfile();
        this.close();
        const nativeButton = this.findNativeWriteButton();
        if (!nativeButton) {
          this.status.textContent = 'The review form is still loading. Please try again in a moment.';
          return;
        }
        this.bypassNativeButton = true;
        nativeButton.click();
        requestAnimationFrame(() => this.showProfileSummaryInNativeForm());
      }

      findReviewTextarea() {
        const candidates = [...document.querySelectorAll('#judgeme_product_reviews textarea, .jdgm-review-widget textarea, .jdgm-review-widget-modal textarea, .jdgm-write-review-modal textarea, .jm-review-form textarea, .jdgm-form-wrapper textarea, [class*="jm-review-form"] textarea, [class*="jdgm-form"] textarea')];
        return candidates.find((textarea) => /review|body|content/i.test(`${textarea.name} ${textarea.id} ${textarea.placeholder}`)) || candidates[0];
      }

      showProfileSummaryInNativeForm() {
        if (!this.pendingProfile) return;
        const textarea = this.findReviewTextarea();
        if (!textarea || textarea.dataset.dlProfileReady) return;
        textarea.dataset.dlProfileReady = 'true';
        textarea.placeholder = 'Tell us how the grip felt, fit, and supported your routine.';
        const details = this.parseProfile(this.pendingProfile);
        const summary = document.createElement('div');
        summary.className = 'dl-review-form-summary';
        summary.innerHTML = `<strong>Your optional details</strong>${details.map((item) => `<span>${this.escapeHtml(item.label)}: ${this.escapeHtml(item.value)}</span>`).join('<br>')}`;
        textarea.parentElement?.insertBefore(summary, textarea);
      }

      prependProfileToReview() {
        if (!this.pendingProfile) return;
        const textarea = this.findReviewTextarea();
        if (!textarea || !textarea.value.trim() || textarea.value.includes('[DL_PROFILE]')) return;
        textarea.value = `${this.pendingProfile}${textarea.value.trim()}`;
        textarea.dispatchEvent(new Event('input', { bubbles: true }));
        textarea.dispatchEvent(new Event('change', { bubbles: true }));
        this.pendingProfile = '';
      }

      parseProfile(text) {
        const match = text.match(/\[DL_PROFILE\]([\s\S]*?)\[\/DL_PROFILE\]/);
        if (!match) return [];
        return match[1].trim().split(/\r?\n/).map((line) => {
          const separator = line.indexOf(':');
          return separator > -1 ? { label: line.slice(0, separator).trim(), value: line.slice(separator + 1).trim() } : null;
        }).filter(Boolean);
      }

      decorateReviews() {
        document.querySelectorAll('#judgeme_product_reviews .jm-review-content__body, #judgeme_product_reviews .jdgm-rev__body').forEach((body) => {
          if (body.dataset.dlDecorated) return;
          const text = body.textContent || '';
          const details = this.parseProfile(text);
          if (!details.length) return;
          const cleanBody = text.replace(/\[DL_PROFILE\][\s\S]*?\[\/DL_PROFILE\]\s*/, '').trim();
          const tags = document.createElement('div');
          tags.className = 'dl-review-profile';
          details.forEach((item) => {
            const tag = document.createElement('span');
            tag.className = 'dl-review-profile__tag';
            tag.textContent = `${item.label}: ${item.value}`;
            tags.appendChild(tag);
          });
          body.textContent = cleanBody;
          body.parentElement?.insertBefore(tags, body);
          body.dataset.dlDecorated = 'true';
        });
      }

      escapeHtml(value) {
        const node = document.createElement('div');
        node.textContent = value;
        return node.innerHTML;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dreamlover-reviews-preview"] && !Shopify.designMode) return;
  try {
    
  class DreamloverReviewPreview extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-review-dialog]');
      this.openButton = this.querySelector('[data-review-dialog-open]');
      this.openButton?.addEventListener('click', () => this.open());
      this.querySelectorAll('[data-review-dialog-close]').forEach((button) => button.addEventListener('click', () => this.close()));
      this.dialog?.addEventListener('click', (event) => { if (event.target === this.dialog) this.close(); });
      this.querySelectorAll('[data-preview-filter]').forEach((button) => button.addEventListener('click', () => { const active = button.classList.toggle('is-active'); button.setAttribute('aria-pressed', String(active)); }));
      this.querySelectorAll('[data-review-tab]').forEach((button) => button.addEventListener('click', () => this.showTab(button.dataset.reviewTab)));
      this.querySelectorAll('[data-rating]').forEach((button) => button.addEventListener('click', () => this.setRating(Number(button.dataset.rating))));
      this.querySelectorAll('[data-choice]').forEach((button) => button.addEventListener('click', () => {
        const group = button.closest('[data-choice-mode]');
        if (group?.dataset.choiceMode === 'single') group.querySelectorAll('[data-choice]').forEach((option) => option.setAttribute('aria-pressed', 'false'));
        button.setAttribute('aria-pressed', String(button.getAttribute('aria-pressed') !== 'true'));
      }));
      this.querySelector('[data-form-next]')?.addEventListener('click', () => this.showStep('questions'));
      this.querySelector('[data-form-back]')?.addEventListener('click', () => this.showStep('rating'));
      this.querySelectorAll('[data-helpful]').forEach((button) => button.addEventListener('click', () => { const active = button.getAttribute('aria-pressed') === 'true'; button.setAttribute('aria-pressed', String(!active)); button.firstChild.textContent = active ? '♡ Helpful ' : '♥ Helpful '; const count = button.querySelector('span'); count.textContent = String(Number(count.textContent) + (active ? -1 : 1)); }));
    }
    open() { if (this.dialog?.showModal) this.dialog.showModal(); else this.dialog?.setAttribute('open',''); document.documentElement.style.overflow='hidden'; }
    close() { if (this.dialog?.close) this.dialog.close(); else this.dialog?.removeAttribute('open'); document.documentElement.style.removeProperty('overflow'); this.openButton?.focus(); }
    showTab(name) { this.querySelectorAll('[data-review-tab]').forEach((button) => button.setAttribute('aria-selected', String(button.dataset.reviewTab === name))); this.querySelectorAll('[data-review-panel]').forEach((panel) => panel.hidden = panel.dataset.reviewPanel !== name); }
    showStep(name) { this.querySelectorAll('[data-form-step]').forEach((step) => { const active=step.dataset.formStep===name; step.hidden=!active; step.classList.toggle('is-active',active); }); }
    setRating(value) { this.querySelectorAll('[data-rating]').forEach((button) => { const active=Number(button.dataset.rating)<=value; button.textContent=active?'★':'☆'; button.setAttribute('aria-pressed',String(Number(button.dataset.rating)===value)); }); this.querySelector('[data-form-next]').disabled=false; }
  }
  if (!customElements.get('dreamlover-review-preview')) customElements.define('dreamlover-review-preview', DreamloverReviewPreview);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
